import { useEffect, useRef, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
const isResizable = (element) => typeof element.handleResize === 'function';
const resizeObserver = new ResizeObserver(entries => {
    if (!Array.isArray(entries) || !entries.length) {
        return;
    }
    for (const entry of entries) {
        if (isResizable(entry.target)) {
            entry.target.handleResize(entry.contentRect);
        }
    }
});
/**
 * Хук для трекинга изменения ширина/высоты элемента.
 */
export function useResizeObserver() {
    const ref = useRef(null);
    const [width, changeWidth] = useState(0);
    const [height, changeHeight] = useState(0);
    useEffect(() => {
        const element = ref.current;
        if (element) {
            element.handleResize = contentRect => {
                changeWidth(contentRect.width);
                changeHeight(contentRect.height);
            };
            resizeObserver.observe(element);
        }
        return () => {
            if (element) {
                resizeObserver.unobserve(element);
            }
        };
    }, []);
    return [ref, width, height];
}
